import React from 'react';
import { Link } from 'gatsby';
import { GatsbySeo, ProductJsonLd } from 'gatsby-plugin-next-seo';
import Container from '@mui/material/Container';
import parse, { domToReact, attributesToProps } from 'html-react-parser';
import PageLayout from '../../containers/PageLayout';
import * as styles from './index.module.css';

import Bio from './bio';
import ReadMore from './read-more';
import Share from './share';
import Topics from './topics';

export interface Site {
  siteMetadata: {
    title: string;
    description: string;
    siteUrl: string;
  };
}

export interface MarkdownRemark {
  id: string;
  fields: {
    slug: string;
  };
  html: string;
  frontmatter: {
    url: string;
    title: string;
    date: string;
    destopicscription: string;
    topics: string;
    thumbnail: {
      childImageSharp: {
        gatsbyImageData: any;
      };
    };
  };
}

interface Props {
  data: {
    site: Site;
    markdownRemark: MarkdownRemark;
  };
}

const BlogPage: React.FC<Props> = ({ data }) => {
  const post = data.markdownRemark;

  const domToReactOptions = {
    replace: (domNode) => {
      if (domNode && domNode.name === 'img') {
        const props = attributesToProps(domNode.attribs);
        return (
          <img
            style={{
              position: 'relative',
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              width: '100%',
              maxWidth: '1000px',
            }}
            {...props}
          />
        );
      }
    },
  };

  return (
    <PageLayout>
      <GatsbySeo
        title={post.frontmatter.title}
        description={post.frontmatter.description}
        titleTemplate="%s | Pagani Design Watch Official Store"
      />
      <Container disableGutters maxWidth="lg" sx={{ p: 2 }}>
        <article className={styles.blogPost} itemScope itemType="http://schema.org/Article">
          <header>
            <h1 itemProp="headline">{post.frontmatter.title}</h1>
          </header>

          <section itemProp="articleBody">{parse(post.html, domToReactOptions)}</section>

          <Share url={data.site.siteMetadata.siteUrl + '/blog' + post.frontmatter.url} />

          <Topics topics={post.frontmatter.topics} />

          <footer>
            <Bio />
          </footer>
        </article>

        <ReadMore displayCount={3} isHome={false} exclude={post.id} />
      </Container>
    </PageLayout>
  );
};

// dangerouslySetInnerHTML={{ __html: post.html }}

// style = position: relative; display: block; margin-left: auto; margin-right: auto; width: 100%; max-width: 1000px;
export default BlogPage;
